"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectAuditLogPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const lodash_1 = __importDefault(require("lodash"));
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const AuditLogPageDataProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageDataProvider");
const AuditLogPageModelProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageModelProvider");
const AuditLogTable_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/AuditLogTable");
const FormComponent_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/form/FormComponent");
const react_router_dom_1 = require("react-router-dom");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const i18_1 = require("src/configeek_assets/src/i18");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const ProjectUrlProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectUrlProvider");
const Analytics_1 = require("src/configeek_assets/src/system/analytics/Analytics");
const ProjectAuditLogPage = () => {
    const { projectApiKey } = (0, ProjectUrlProvider_1.useProjectUrlContext)();
    const projectParticipantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const hasProjectMemberAccess = appICUtils_1.ParticipantUtils.hasProjectMemberAccess(currentProjectContext.projectData.view.participant);
    (0, react_1.useEffect)(() => {
        Analytics_1.Analytics.trackViewAuditPage();
    }, []);
    (0, react_1.useEffect)(() => {
        if (hasProjectMemberAccess) {
            projectParticipantsDataContext.fetchParticipants();
        }
    }, [hasProjectMemberAccess]);
    if (!hasProjectMemberAccess) {
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.PageHeader, { title: "Audit Log" }),
            React.createElement(PageContent_1.PageContent, { topDivider: true },
                React.createElement(antd_1.Result, { subTitle: i18_1.i18.project.audit.error.table.noAccess.msg, icon: React.createElement(React.Fragment, null), extra: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(projectApiKey, "parameters") },
                        React.createElement(antd_1.Button, null,
                            React.createElement("span", null, i18_1.i18.project.audit.error.table.noAccess.backToParametersLink))) })));
    }
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Audit Log" }),
        React.createElement(PageContent_1.PageContent, null,
            React.createElement(PageContent_1.PageContent.CardSpacer, null),
            React.createElement(PageContent_1.PageContent.Card, null,
                React.createElement(FormComponent_1.FormComponent, null),
                React.createElement(AuditLogTableWrapper, null,
                    React.createElement(AuditLogTable_1.AuditLogTable, null)))));
};
exports.ProjectAuditLogPage = ProjectAuditLogPage;
const AuditLogTableWrapper = (props) => {
    var _a;
    const auditLogPageDataContext = (0, AuditLogPageDataProvider_1.useAuditLogPageDataContext)();
    const auditLogPageModelContext = (0, AuditLogPageModelProvider_1.useAuditLogPageModelContext)();
    const { inProgress, loaded } = auditLogPageDataContext.state.status;
    const hasAuditLogRecords = !lodash_1.default.isEmpty((_a = auditLogPageDataContext.state.data) === null || _a === void 0 ? void 0 : _a.auditLogRecords);
    if (!loaded) {
        return React.createElement(React.Fragment, null,
            React.createElement(PageLoaderComponent_1.PageLoaderComponent, { marginTop: "30px" }));
    }
    if (auditLogPageDataContext.state.error.isError) {
        // const error: Error = auditLogPageDataContext.state.error.error || new Error("unknown")
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.Result, { title: i18_1.i18.common.error.oops.title, icon: React.createElement(React.Fragment, null), extra: React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: auditLogPageModelContext.pageModelStateFns.show, disabled: inProgress, loading: inProgress }, i18_1.i18.common.error.tryAgain) }));
    }
    if (!hasAuditLogRecords) {
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.Result, { title: i18_1.i18.project.audit.noRecordsStub.title, icon: React.createElement(React.Fragment, null) }));
    }
    return React.createElement(React.Fragment, null, props.children);
};
const DebugView = () => {
    const pageDataContext = (0, AuditLogPageDataProvider_1.useAuditLogPageDataContext)();
    const pageModelContext = (0, AuditLogPageModelProvider_1.useAuditLogPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.PageContent.CardSpacer, null),
        React.createElement(PageContent_1.PageContent.Card, null,
            React.createElement(antd_1.Row, { gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 24 },
                    "location:",
                    React.createElement("br", null),
                    React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                React.createElement(antd_1.Col, { span: 8 },
                    "pageModelFormState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageModelContext.pageModelFormState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataURLState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.urlState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.state, null, 4)))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)));
};
